<app-layout columnCount="4">
  <app-layout-title>
    <app-go-back-button (click)="goBack()">{{ 'ADMIN.webhook_create' | translate }}</app-go-back-button>
  </app-layout-title>

  <app-layout-content>
    <form [formGroup]="webhookForm" class="grid">
      <mat-form-field>
        <mat-label>{{ 'ADMIN.url' | translate }}</mat-label>
        <input type="url" formControlName="url" matInput>
      </mat-form-field>

      <app-select formControlName="event">
        <app-select-label>{{ 'WEBHOOKS.event' | translate }}</app-select-label>
        @for (event of events$ | async; track event) {
          <mat-option [value]="event.key">{{ event.value }}</mat-option>
        }
      </app-select>

      <div class="retries-head">
        <p>{{ 'WEBHOOKS.retries' | translate }}</p>

        <div>
          <button (click)="addInterval()"
            color="primary"
            mat-icon-button
            [matTooltip]="'ADMIN.add_interval' | translate">
            <mat-icon>add</mat-icon>
          </button>
          <button (click)="removeInterval()"
            [disabled]="!webhookForm.controls.retries.value.length"
            color="warn"
            mat-icon-button
            [matTooltip]="'ADMIN.remove_interval' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="retries" formArrayName="retries">
        @for (retry of retries.controls; track retry; let i = $index) {
          <mat-form-field>
            <input type="number" min="1" matInput [formControlName]="i.toString()">
          </mat-form-field>
        }
      </div>

      <mat-slide-toggle formControlName="isActivated">
        {{ (webhookForm.value['isActivated'] ? 'NOTICES_EDITOR.deactivate' : 'NOTICES_EDITOR.activate') | translate }}
      </mat-slide-toggle>
    </form>

    <app-button-group>
      <button (click)="createWebhook()" color="primary" mat-raised-button>
        {{ 'COMMON.save' | translate }}
      </button>
    </app-button-group>
  </app-layout-content>
</app-layout>
